<template>
  <div>
    <Modal v-model="isShow" :mask-closable="false"
           @on-ok="ok" :loading="loading" @on-cancel="cancel"
           :width="800"
    >
      <h3 slot="header" class="modal-header">发送签约邀请</h3>
      <div class="specialdrop" v-if="item">
        <div class="mb8">
          <span class="left">项目信息</span>
          <span class="right">{{item.projectName}}</span>
        </div>
        <div class="mb8">
          <span class="left">房间信息</span>
          <span class="right">{{stockNumber}}</span>
        </div>
        <div class="mb8">
          <span class="left">签约手机号</span>
          <span class="right">
            <Input class="inputwidth" :value="phone" disabled/>
          </span>
        </div>
        <div class="mb8">
          <span class="left">租期方式</span>
          <span class="right" style="position: relative">
            <Select v-model="conType" style="width: 150px" @on-change="changeType">
              <Option value="">请选择</Option>
              <Option v-for="(item,index) in leaseTime" :value="item.value" :key="'keyA'+index">{{item.text}}</Option>
            </Select>
          </span>
        </div>
        <div class="mb8" v-if="conStartDate">
          <span class="left">租期时间</span>
          <span class="right" style="position: relative">
            <DatePicker placeholder="起租日" disabled v-model="conStartDate"></DatePicker> -
            <DatePicker v-if="conType===1" placeholder="到期日" v-model="conEndDate" :options="option1"></DatePicker>
            <DatePicker v-if="conType===2" v-model="conEndDate" :options="option2" :start-date="option2.minTime"></DatePicker>
            <DatePicker v-if="conType===0" v-model="conEndDate" disabled></DatePicker>
            <DatePicker v-if="conType===''" disabled></DatePicker>
            <span class="ivu-btn" v-if="year">{{year}}年</span>
            <span class="ivu-btn" v-if="monthAndDay.month">{{monthAndDay.month}}月</span>
            <span class="ivu-btn" v-if="monthAndDay.day">{{monthAndDay.day}}天</span>
          </span>
        </div>
      </div>
      <Table class="mt20" :columns="columns" :data="signInviteList"></Table>
    </Modal>
  </div>
</template>
<script>
  import {getSignInviteInfo, saveSignInviteInfo, validSignInvite} from "../../../../api/contractList";
  import {formatDateTime} from "../../../../utils/format";

  export default {
    name: "SendSign",
    components: {},
    props: {
      item: {
        type: Object,
        default: null
      },
      n: {
        type: Number,
        default: 0
      },
      stockFid: {
        type: String,
        default: null

      },
      contractFid: {
        type: String,
        default: null
      },
      contractCode: {
        type: String,
        default: null
      },
      stockNumber: {
        type: String,
        default: null
      }
    },
    watch: {
      n() {
        this.cleanData()
        this.getSignInviteInfo()
        this.isShow = true
      }
    },
    computed: {
      monthAndDay() {
        const ret = {
          month: '',
          day: ''
        }
        if (!this.conStartDate || !this.conEndDate || (this.conType === 1)) {
          return ret
        }
        const year1 = this.conStartDate.getFullYear()
        const month1 = this.conStartDate.getMonth()
        const day1 = this.conStartDate.getDate()
        const year2 = this.conEndDate.getFullYear()
        const month2 = this.conEndDate.getMonth()
        const day2 = this.conEndDate.getDate()
        const lasttmonthdays = new Date(year2, month2, 0).getDate()

        const diffM = month2 - month1
        const diffD = day2 - day1

        if (year1 == year2) {
          if (diffD >= 0) {
            ret.day = diffD + 1
            ret.month = month2 - month1
          } else if (diffD == -1) {
            ret.day = 0
            ret.month = diffM
          } else {
            ret.day = diffD + lasttmonthdays + 1
            ret.month = diffM - 1
          }
        }
        else {
          if (diffD >= 0) {
            ret.day = diffD + 1
            ret.month = diffM + 12
          } else if (diffD == -1) {
            ret.day = 0
            ret.month = diffM + 12

          } else {
            ret.day = diffD + lasttmonthdays + 1

            ret.month = diffM + 12 - 1
          }
        }
        return ret
      },
      option2() {

        if (!this.conStartDate || !this.rentTermMonthStart || !this.rentTermMonthEnd) {
          return {}
        }
        const min = this.rentTermMonthStart
        const max = this.rentTermMonthEnd

        let minTime = this.conStartDate.valueOf() + 3600 * 24 * 1000 * (min - 2)
        let maxTime = this.conStartDate.valueOf() + 3600 * 24 * 1000 * (max - 1)
        minTime = minTime > this.stockMaxSignDate ? this.stockMaxSignDate : minTime
        maxTime = maxTime > this.stockMaxSignDate ? this.stockMaxSignDate : maxTime

        return {
          disabledDate(date) {
            return date && date.valueOf() < minTime || date.valueOf() > maxTime;
          },
          minTime: new Date(minTime)
        }
      },
      option1() {
        if (!this.conStartDate || !this.rentTermYearStart || !this.rentTermYearEnd) {
          return {}
        }
        const shortcuts = []
        const year = this.conStartDate.getFullYear()
        const month = this.conStartDate.getMonth()
        const date = this.conStartDate.getDate()
        for (let i = this.rentTermYearStart; i <= this.rentTermYearEnd; i++) {
          const num1 = (new Date(year + i, month, date - 1)).valueOf()
          if (num1 > Number(this.stockMaxSignDate)) {
            break;
          }
          shortcuts.push({
            text: i + '年',
            value() {
              return (year + i) + '-' + (month + 1) + '-' + (date - 1)
            },
            onClick: () => {
              this.year = i
            }
          })
        }
        return {
          shortcuts: shortcuts,
          disabledDate() {
            return true
          }
        }
      }

    },
    data() {
      return {
        responseDate: null,
        year: '',
        loading: true,
        isShow: false,
        columns: [
          {
            type: 'index',
            width: 60,
            align: 'center'
          },
          {
            title: "签约手机号",
            key: "userPhone",
            align: "center"
          },
          {
            title: "租期类型",
            key: "rentTypeName",
            align: "center"
          },
          {
            title: "起租日",
            key: "conStartDate",
            align: "center",
            render: (h, params) => {
              return h('span', {}, this.format(params.row['conStartDate']))
            }
          },
          {
            title: "到期日",
            key: "conEndDate",
            align: "center",
            render: (h, params) => {
              return h('span', {}, this.format(params.row['conEndDate']))
            }
          },
          {
            title: "ZO",
            key: "handleZo",
            align: "center"
          },
          {
            title: "发送日期",
            key: "createTime",
            align: "center",
            render: (h, params) => {
              return h('span', {}, this.format(params.row['createTime']))
            }
          },
        ],
        projectName: '',
        phone: '',
        conType: '',
        leaseTime: [],//[{text:'年租',value:1},{text:'月租',value:2},{text:'尾房',value:0}],
        signInviteList: [],
        conStartDate: "",
        rentTermYearStart: '',
        rentTermYearEnd: '',
        rentTermMonthStart: '',
        rentTermMonthEnd: '',
        stockMaxSignDate: '',
        conEndDate: ''
      }
    },
    methods: {
      format(data) {
        if (!data) {
          return ''
        }
        return formatDateTime(data, false)

      },
      cleanData() {
        this.conType = ''
        this.leaseTime = []
        this.signInviteList = []
        this.conStartDate = ""
        this.conEndDate = ''
        this.rentTermYearStart = ''
        this.rentTermYearEnd = ''
        this.rentTermMonthStart = ''
        this.rentTermMonthEnd = ''
        this.stockMaxSignDate = ''
        this.responseDate = null
      },
      changeType(value) {
        if (value === 0) {
          this.conEndDate = this.stockMaxSignDate
        }
        else {
          this.conEndDate = ''
        }
        this.year = ''
      },
      // validatePhone() {
      //   let params = {
      //     phone: this.phone
      //   }
      //   validSignInvite(params).then(res => {
      //   }).catch(error => {
      //
      //   })
      // },
      getSignInviteInfo() {
        if (!this.stockFid || !this.contractFid || !this.contractCode) {
          return
        }
        const params = {
          stockFid: this.stockFid,
          contractFid: this.contractFid,
          contractCode: this.contractCode
        }
        getSignInviteInfo(params).then(res => {
          if (!res.data) {
            return
          }
          const data = res.data
          // this.projectName = data.projectName
          this.phone = data.phone
          this.leaseTime = data.leaseTime
          data.signInviteList && (this.signInviteList = data.signInviteList)
          this.rentTermYearStart = data.rentTermYearStart
          this.rentTermYearEnd = data.rentTermYearEnd
          this.rentTermMonthStart = data.rentTermMonthStart
          this.rentTermMonthEnd = data.rentTermMonthEnd
          this.conStartDate = new Date(data.conStartDate)
          this.stockMaxSignDate = new Date(data.stockMaxSignDate)
          this.leaseTime.length > 0 && (this.conType = this.leaseTime[0].value)
          this.responseDate = res.data
        }).catch(error => {
          this.isShow = false
        })
      },
      changeLoading() {
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true
        })
      },
      ok() {
        if (!this.conType && this.conType !== 0) {
          this.$Message.info('请选择租期方式')
          this.changeLoading()
          return
        }
        if (!this.conEndDate) {
          this.$Message.info('请选择到期日')
          this.changeLoading()
          return
        }
        const params = {
          "cityCode": this.responseDate.cityCode,
          "conEndDate": this.format(this.conEndDate),
          "conStartDate": this.format(this.conStartDate),
          "conType": this.conType,
          "contractFid": this.contractFid,
          // "contractId": this.contractFid,
          "houseNumber": this.stockNumber,
          "phone": this.phone,
          "contractCode": this.item.contractCode,
          // "preContractId": this.item.contractCode,
          "projectCode": this.responseDate.projectCode,
          "projectCooperationModel": this.responseDate.projectCooperationModel,
          "projectId": this.item.projectFid,
          "projectName": this.item.projectName,
          "roomIds": this.responseDate.stockFid,
          "signContractType": this.item.contractType,
          // "source": this.item.source,
          "stockMaxSignDate": this.responseDate.stockMaxSignDate,
          "stockType": this.responseDate.stockType,
          stockRentType: this.responseDate.stockRentType
        }
        saveSignInviteInfo(params).then(res => {
          this.$Message.success('发送个人签约邀请成功')
          this.$emit('done')
          this.isShow = false
        }).catch(error => {
          // this.isShow = false
          this.changeLoading()
        })
      },
      cancel() {
      }
    }

  }
</script>

<style scoped>
  .left, .right {
    display: inline-block;
    line-height: 2.5;
  }

  .left {
    width: 100px;
    /*text-align: right;*/
    margin-left: 20px;
  }

  .inputwidth {
    width: 200px;
  }

</style>
